import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=3e71be4c&scoped=true"
var script = {}
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=3e71be4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e71be4c",
  null
  
)

export default component.exports